import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { handleChangeDataModalEditFromStock } from '../../../../redux/actions/partials/modals/modalEditFromStock';
import { handleChangeDataProductsPage } from '../../../../redux/actions/pages/products';
import { EDIT_PRODUCT_FROM_STOCK_POST } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 


const ModalEditFromStock = (props) => {

	const dispatch = useDispatch();

	const { isOpen, product, inventory, price, priceOld, productKey } = useSelector(state => state.modalEditFromStock);
	const { token } = useSelector(state => state.login);
	const { myProducts } = useSelector(state => state.products);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);

    console.log('arash');
    console.log(product);
    console.log(inventory);
    console.log(price);
    console.log(priceOld);
    console.log(productKey);

    useEffect(() => {
        if(isOpen) {
            dispatch(handleChangeDataModalEditFromStock('inventory', product.inventory));
            dispatch(handleChangeDataModalEditFromStock('price', product.priceTxt));
            dispatch(handleChangeDataModalEditFromStock('priceOld', product.oldPrice !== null ? product.oldPriceTxt : ""));
        }
        // eslint-disable-next-line
    }, [isOpen]);

	const handleClose = () => {
        dispatch(handleChangeDataModalEditFromStock('isOpen', false));
    };    

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalEditFromStock(name, value));
    };

    const handelNumericInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataModalEditFromStock(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
    };

    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    const handleSubmitForm = () => {
    	if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: EDIT_PRODUCT_FROM_STOCK_POST,
                method: 'post',
                data: {
                	product: product.productId,
                	variant: product.variantId,
                	inventory, 
                	price: removeNonNumeric(changeNumberPersianAndArabic(price)), 
                	priceOld: removeNonNumeric(changeNumberPersianAndArabic(priceOld))
                },
                token: token,
                successMessage: 'محصول مورد نظر با موفقیت ویرایش شد',
                onSuccess: (res) => {
                	let newProoducts = [...myProducts];
                	newProoducts[productKey].price = (removeNonNumeric(changeNumberPersianAndArabic(price)) * 10).toString();
                    newProoducts[productKey].priceTxt = price;
                    newProoducts[productKey].oldPrice = removeNonNumeric(changeNumberPersianAndArabic(priceOld)) > '0' ? (removeNonNumeric(changeNumberPersianAndArabic(priceOld)) * 10).toString() : null;
                    newProoducts[productKey].oldPriceTxt = priceOld;
                    newProoducts[productKey].inventory = inventory;
                    dispatch(handleChangeDataProductsPage('myProducts', newProoducts));

                    dispatch(handleChangeDataModalEditFromStock('inventory', ''));
                    dispatch(handleChangeDataModalEditFromStock('price', ''));
                    dispatch(handleChangeDataModalEditFromStock('priceOld', ''));
                    dispatch(handleChangeDataModalEditFromStock('productKey', 0));
                    dispatch(handleChangeDataModalEditFromStock('isOpen', false));
                },
            });
        }
    	
    };

    return (
        <Modal show={isOpen} onHide={handleClose} className={`modal fade text-xs-left ${isOpen ? 'in' : ''}`} dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen-sm-down' style={{marginTop: '90px'}}>
        	<div className="modal-dialog modal-lg" role="document" style={{marginTop: '0', marginBottom: '0'}}>
        		<div className="modal-content" >
        			<div className="modal-header">
		                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                <h4 className="modal-title" id="myModalLabel17">{product.productTitle} {product.attributeTitle !== null ? (product.attributeTitle + ": " + product.attributeOptionTitle) : ""}</h4>
		            </div>
		            <form>
			            <div className="modal-body pb-0">
			            	<label>موجودی</label>
							<div className="form-group">
								<input type="number" placeholder="" className="form-control" name="inventory" value={inventory} onChange={handleChangeInputs} />
							</div>
			            </div>
			            <div className="modal-body py-0">
			            	<label>قیمت نهایی</label>
							<div className="form-group">
								<input type="text" inputMode="numeric" placeholder="تومان" className="form-control" name="price" value={price} onChange={handelNumericInputs} />
							</div>
			            </div>
			            <div className="modal-body py-0">
			            	<label>قیمت قبل از تخفیف (اختیاری)</label>
							<div className="form-group">
								<input type="text" inputMode="numeric" placeholder="تومان" className="form-control" name="priceOld" value={priceOld} onChange={handelNumericInputs} />
							</div>
			            </div>
			            <div className="modal-footer">
			                <button type="button" className="btn grey btn-outline-secondary" data-dismiss="modal" onClick={handleClose}>بستن</button>
			                <button type="button" className="btn btn-outline-primary ml-2" data-dismiss="modal" onClick={handleSubmitForm}>ویرایش</button>
			            </div>
		            </form>
        		</div>
        	</div>

        </Modal>
    );
}

export default ModalEditFromStock;
